module.exports = __webpack_public_path__ + "static/page_layout_themes-1898379cd9ddedb89ca32a346077a7f9.png";